import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container, Table} from 'react-bootstrap';
import Sidebar from './Sidebar';
import ToastConfirmation from './ToastConfirmation';
import {
  getResources,
  deleteResource,
  uploadResource
} from './apiCalls';

export default function Resources() {

  const { WEB_FOLDER } = window.config;

  const [showToaster, setShowToaster] = useState(false);
  const [resources, setResources] = useState([]);
  const [fileName, setFileName] = useState('');
  const [fileData, setFileData] = useState('');
  const [fileNewName, setFileNewName] = useState('Nombre de archivo (sin extensión)');


  useEffect(() => {
    getResources(setResources);
  }, []);

  const handleDeleteResource = (name) => {
    deleteResource(name)
    .then(() => setShowToaster(true))
    .then(() => getResources(setResources));
  };

  const handleAddResource = () => {
    uploadResource(fileNewName, fileName, fileData, () => {})
    .then(() => getResources(setResources))
    .then(() => setShowToaster(true));
  };

  const resourcesContent = (
    <>
    <p>{/* JSON.stringify(odiseaForm) */}</p>
    <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
    <Form>
      <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>URL</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            resources && resources.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td>
                    { item }
                  </td>
                  <td>
                    { `${WEB_FOLDER}/uploads/${item}` }
                  </td>
                  <td>
                  {
                    ['bg', 'logo'].includes(item.split('.')[0]) ?
                      (<p>Obligatorio</p>) :
                      (<Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteResource(item)}}>Eliminar</Button>)
                  }
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      </Form.Group>
    </Form>
    </>
  );

  const newResource = (
    <Form>
      <Form.Group className="admin-content-group">
        <Form.Control
          placeholder="Nombre de archivo"
          defaultValue={ 'Nombre de archivo (sin extensión)' }
          required
          onChange={ (e) => {
            setFileNewName(e.target.value);
          } }  
        />
        <Form.Label></Form.Label>
        <Form.Control type="file"
          required
          onChange={(e) => {
            setFileName(e.target.value);
            setFileData(e.target.files[0]);
          }}
        />
    </Form.Group>
    <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddResource()}}>Agregar Recurso</Button>
  </Form>
  );

  return (
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <Card>
              <Card.Header>Gestión de recursos</Card.Header>
              <Card.Body>{ resourcesContent }</Card.Body>
            </Card>
            <Card>
              <Card.Header>Subir un nuevo recurso</Card.Header>
              <Card.Body>{ newResource }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
